import {Box} from '@mui/material';
import React from 'react';

export const Line = props => (
  <Box
    sx={{
      position: 'absolute',
      height: 2,
      bgcolor: 'grey.200',
      right: 0,
      left: 0,
      top: 8 * 3.5,
      alignSelf: 'center',
    }}
    {...props}
  />
);
